module.exports = __webpack_public_path__ + "files/214376adb24815606515066c63c5117c.png";